import axios from "axios";
import WorkspaceService from "@/src/api/WorkspaceService.js";
import { isPublicRoute } from "@/src/constants/routeConstants.js";

const csrfToken = document.querySelector('[name="csrf-token"]') ||
  document.head.querySelector('meta[name="csrf-token"]') || {
    content: "no-csrf-token",
  };

const url = window.location.href.includes("localhost")
  ? "http://localhost:3000"
  : `${window.location.origin}`;

let BASE_PATH =
  process.env.NODE_ENV === "development" ? url : window.location.href.includes("in.superagi.com")
    ? "https://sales.in.superagi.com"
    : "https://sales.superagi.com";

if (process.env.NODE_ENV === "staging" || process.env.NODE_ENV === "production") {
  BASE_PATH = `${window.location.origin}`;
}

if (window.location.href.includes("hr.superagi.com")) {
  BASE_PATH = "https://hr.superagi.com";
}

export const transport = axios.create({
  baseURL: BASE_PATH,
  withCredentials: true,
  headers: {
    common: {
      "X-CSRF-Token": csrfToken.content,
    },
  },
});

// Request interceptor to set workspace ID dynamically on each request
transport.interceptors.request.use(
  (config) => {
    const workspaceId = WorkspaceService.getCurrentWorkspaceId();
    if (workspaceId) {
      config.headers['X-Workspace-Id'] = workspaceId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

transport.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;
      
      if (!isPublicRoute(currentPath)) {
        setTimeout(() => {
          const host = window.location.hostname;
          let redirectUrl;
          if (host === "sales-staging.superagi.com") {
            redirectUrl = "https://staging.superagi.com/";
          } else if (host === "sales.superagi.com") {
            redirectUrl = "https://superagi.com/";
          } else {
            redirectUrl = `${window.location.origin}/auth_users?session_expired=true`;
          }
          window.location.replace(redirectUrl);
        }, 100);
      }

      return Promise.reject(error);
    }
    return Promise.reject(error);
  },
);

export { BASE_PATH };

export default {
  transport,
  BASE_PATH,
};
